import React from 'react';
import { Button, Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './quote-carousel.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CAROUSEL_ITEMS = [
  { image: '/assurmaxpro-mri.jpg', link: '/quotes/mriml/create' },
  {
    image: '/assurmaxpro-mrp-mre.jpg',
    link: '/quotes/mrp/create?mrpT=any&sup=ml'
  },
  { image: '/assurmaxpro-pno-pne.jpg', link: '/quotes/mriml/create' },
  { image: '/assurmaxpro-rcp-rce.jpg', link: '/quotes/rcp/create?sup=ml' }
];

const QuoteCarousel = () => {
  const carouselRef = React.useRef();
  const { t } = useTranslation();

  const handlePrev = () => {
    if (carouselRef?.current) {
      carouselRef.current.prev();
    }
  };

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const renderCarouselQuoteButton = () => {
    return (
      <div className="button-triangle-container">
        <div className="button-triangle" />
        <Button
          type="ghost"
          style={{
            borderRadius: 0,
            height: 60,
            width: '100%',
            backgroundColor: 'white',
            border: 'none',
            borderColor: 'white',
            fontSize: 20
          }}
        >
          {`${t('home.quoteCarousel.title')} `}
        </Button>
      </div>
    );
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        paddingLeft: '30px',
        paddingRight: '30px'
      }}
    >
      <button
        type="button"
        onClick={handlePrev}
        className="arrow-button"
        style={{ left: '30px' }}
      >
        <LeftOutlined style={{ fontSize: '24px' }} />
      </button>
      <Carousel ref={carouselRef}>
        {CAROUSEL_ITEMS.map((item) => (
          <Link
            key={item.image}
            to={item.link}
            style={{ width: '700px', height: '500px' }}
          >
            <div
              className="carousel-item"
              style={{
                backgroundImage: `url(${item.image})`
              }}
            >
              <div className="button-container">
                {renderCarouselQuoteButton()}
              </div>
            </div>
          </Link>
        ))}
      </Carousel>
      <button
        type="button"
        onClick={handleNext}
        className="arrow-button"
        style={{ right: '30px' }}
      >
        <RightOutlined style={{ fontSize: '24px' }} />
      </button>
    </div>
  );
};

export default QuoteCarousel;
